import useSWR from 'swr';
import fetcher from 'lib/fetcher';
import { ISelectItem } from 'lib/types';
import { sortByTitle } from 'lib/utils';

export type IStreetByBuildingResponse = {
  name: string;
  city: string;
  id: number;
}[];

export const useStreetList = (isTransformForSelect?: boolean, isFetch: boolean = true) => {
  const { data, error, isLoading, mutate } = useSWR<IStreetByBuildingResponse>(
    '/building/street-by-building',
    isFetch ? fetcher.swr : null,
    {
      revalidateOnFocus: false,
      revalidateOnMount: false,
      revalidateOnReconnect: false,
      refreshWhenOffline: false,
      refreshWhenHidden: false,
      refreshInterval: 0,
    },
  );

  const transformData = (dataList: IStreetByBuildingResponse | undefined): ISelectItem[] => {
    if (dataList) {
      const dataTransformed = dataList.map((item) => ({
        key: item.id,
        label: item.name,
        note: item.city,
      }));
      return sortByTitle(dataTransformed) as ISelectItem[];
    }
    return [];
  };

  return {
    streets: isTransformForSelect ? transformData(data) : data ? data : [],
    error,
    isLoading,
    mutate,
  };
};

export default useStreetList;
